module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Widen_AG-9749f1040c66a08f87d695384b899a89.svg";